import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { microAppInitialized } from '@mynexus/mfe-core';

@Component({
    selector: 'app-reporting',
    templateUrl: './mnc-reporting.component.html',
    styleUrls: ['./mnc-reporting.component.scss'],
    standalone: false
})
export class MncReportingComponent implements AfterViewInit {
  constructor(
    private ref: ElementRef,
    private router: Router
  ) {
    // this is required to trigger the router for the micro app on initial load.
    this.router.initialNavigation();
  }

  @Input() set url(value: string){
    this.router.navigate([value]);
  }

  ngAfterViewInit(): void {
    microAppInitialized(this.ref, this.router, 'Reporting')
  }
}
